export default __webpack_public_path__ + "2b501905f31c3f394ed66e5e36792646.svg";